import AniImg from "../components/AniImg";
import AniTitle from "../components/AniTitle";
import Model from "../../Model/page/Model";
import Filter from "../../Filter/page/Filter";
import Concept from "../../Concept/page/Concept";
import Footer from "../../common/Footer";
import { useTranslation } from "react-i18next";

const MobilePage = () => {
  const { t } = useTranslation();

  return (
    <>
      <AniTitle />
      <AniImg url="/assets/images/sample1.svg" text={t("AniImgTitle_1")} />
      <AniImg url="/assets/images/sample2.svg" text={t("AniImgTitle_2")} />
      <AniImg url="/assets/images/sample3.svg" text={t("AniImgTitle_3")} />
      <AniImg backgroundColor="#fff" color="#000" text={t("AniImgTitle_4")} />
      <Model />
      <Filter />
      <Concept />
      <Footer />
    </>
  );
};

export default MobilePage;
